import { render, staticRenderFns } from "./PaymentMessageListTable.vue?vue&type=template&id=19e61cf3&scoped=true&"
import script from "./PaymentMessageListTable.vue?vue&type=script&lang=js&"
export * from "./PaymentMessageListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e61cf3",
  null
  
)

export default component.exports